export enum FormStep {
    S0_INTRODUCTION,
    S1_CANCELLATION_PARAMS,
    S2_REVIEW_SUBMIT,
    NOT_FEASIBLE,
}
